<template>
  <g>
    <map-path
      v-for="(item, index) in paths"
      :key="index"
      :d="item.d"
      :stroke="item.stroke"
      :fill="item.fill"
      :stroke-width="item.strokeWidth"
      :region="item.name"
      @mouseenter="handleMouseEnter(index, item.data, item.name, $event)"
      @mouseleave="handleMouseLeave(index)"
      @click="handleClick(index, item.data, item.name, $event)"
    />
  </g>
</template>

<script>
import { pick, path } from 'ramda';

import { MapPath } from './regionalMapChart.styles';

export default {
  components: { MapPath },
  props: {
    featureCollection: Object,
    chartData: Object,
    path: Function,
    findInData: Function,
    fill: Function,
    stroke: Function,
    strokeWidth: Function,
    margin: Number,
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    paths() {
      const { fill, stroke, strokeWidth, featureCollection, findInData } = this;

      return featureCollection.features.map((item) => {
        const data = findInData(item);
        const value = pick(this.chartData.series, data);
        const dataProps = {
          data,
          value,
          ...item,
        };
        const name = path(['properties', 'name'], item);
        return {
          d: this.path(item),
          data,
          name,
          fill: fill(dataProps, this),
          stroke: stroke(dataProps, this),
          strokeWidth: strokeWidth(dataProps, this),
        };
      });
    },
  },
  methods: {
    handleMouseEnter(index, data, name, event) {
      this.$emit('enter', index, {
        data,
        name,
        targetBox: event.target.getBoundingClientRect(),
      });
    },
    handleMouseLeave(index) {
      this.$emit('leave', index);
    },
    handleClick(index, data, name) {
      this.$emit('regionClick', { index, name, ...data });
    },
  },
};
</script>
